import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../../AppConfig';
import { CommonStyles } from '../../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button, Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { UiHelper } from '../../common/helpers/UiHelper';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import momentTz from 'moment-timezone';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import { ApiHelperV2 } from '../helpers/ApiHelperV2';
import { Helper } from '../helpers/Helper';
import { Controller } from '../Controller';
import { AppTheme } from '../../styles/AppTheme';

export class EventVideoDialogFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventIndex: this.props.eventIndex,
    }
  }

  componentDidMount() {
    this.setState({ eventIndex: this.props.eventIndex })
  }

  dialogFirst = () => {
    this.setState({ eventIndex: 0 })
  }

  dialogLast = () => {
    const lastValue = this.props.videoData.length - 1
    this.setState({ eventIndex: lastValue })
  }
  dialogNext = (index) => {
    const value = index + 1
    this.setState({ eventIndex: value })
  }

  dialogBefore = (index) => {
    const value = index - 1
    this.setState({ eventIndex: value })
  }

  render() {
    return (
      <Dialog
        onClose={this.props.dialogClose}
        open={this.props.eventDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <div className={css(Styles.dialogTitle)}>
          <p className={css(Styles.dialogTitleContent)}>Videos</p>
          <div className={css(Styles.dialogCloseButton)}>
            <Icon className={css(Styles.closeIcon)} color='secondary' onClick={this.props.dialogClose}>
              cancel
            </Icon>
          </div>
        </div>
        <DialogContent className={css(Styles.dialogContent)}>
          {this.props.videoData.map((item, index) => {
            return (
              index === this.state.eventIndex &&
              <div>
                <div className={css(Styles.eventImageContent)}>
                  <video
                    style={{maxWidth: '100%', maxHeight: '100%'}}
                    videoPlayer
                    id={item._id}
                    src={item.url}
                    // src={require('../../assets/video.mp4')}
                    type='video/mp4'
                    controls
                    autoplay='autoplay'
                    controlsList='nodownload'
                    // error= {this.videoLoadErrHandlerFun}
                    // canplay = {this.canPlayVideoFun}
                  >
                  </video>
                </div>
                <div className={css(Styles.eventControlContent)}>
                  <IconButton color='secondary' disabled={this.state.eventIndex === 0 ? true : false}
                    className={css(Styles.iconButton)}>
                    <Icon
                      className={this.state.eventIndex === 0 ?
                        css(Styles.eventControlIcon, Styles.eventControlIconSelected) : css(Styles.eventControlIcon)}
                      color='secondary' onClick={() => this.dialogFirst()}>
                      first_page
                    </Icon>
                  </IconButton>
                  <IconButton color='secondary' disabled={this.state.eventIndex === 0 ? true : false}
                    className={css(Styles.iconButton)}>
                    <Icon
                      className={this.state.eventIndex === 0 ?
                        css(Styles.eventControlIcon, Styles.eventControlIconSelected) : css(Styles.eventControlIcon)}
                      color='secondary' onClick={() => this.dialogBefore(index)}>
                      navigate_before
                    </Icon>
                  </IconButton>
                  <IconButton color='secondary'
                    disabled={this.state.eventIndex === this.props.videoData.length - 1 ? true : false}
                    className={css(Styles.iconButton)}>
                    <Icon
                      className={this.state.eventIndex === this.props.videoData.length - 1 ?
                        css(Styles.eventControlIcon, Styles.eventControlIconSelected) : css(Styles.eventControlIcon)}
                      color='secondary' onClick={() => this.dialogNext(index)}>
                      navigate_next
                    </Icon>
                  </IconButton>
                  <IconButton color='secondary'
                    disabled={this.state.eventIndex === this.props.videoData.length - 1 ? true : false}
                    className={css(Styles.iconButton)}>
                    <Icon
                      className={this.state.eventIndex === this.props.videoData.length - 1 ?
                        css(Styles.eventControlIcon, Styles.eventControlIconSelected) : css(Styles.eventControlIcon)}
                      color='secondary' onClick={() => this.dialogLast()}>
                      last_page
                    </Icon>
                  </IconButton>
                </div>
                <Divider />
                <div className={css(Styles.eventDetailContent)}>
                  <p className={css(Styles.eventListDate)}>{moment(item.time).format('MMM DD, YYYY, h:mm:ss A')}</p>
                </div>
              </div>
            )
          })}
        </DialogContent>
        <div>
        </div>
      </Dialog>
    )
  }
}

const Styles = StyleSheet.create({
  dialog: {
    width: 500,
  },
  dialogTitle: {
    padding: 10,
    backgroundColor:AppTheme.secondaryBg,
    display: 'flex'
  },
  dialogTitleContent: {
    fontWeight: 600,
    fontSize: 23,
    margin: 0,
    color: 'black'
  },
  dialogCloseButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1,
    alignItems: 'center'
  },
  closeIcon: {
    color: 'black',
    cursor: 'pointer'
  },
  dialogContent: {
    padding: 0,
    overflow: 'hidden'
  },
  eventImageContent: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'black'
  },
  eventControlContent: {
    display: 'flex',
    justifyContent: 'center',
    padding: 10
  },
  iconButton: {
    padding: 0,
  },
  eventControlIcon: {
    borderRadius: '50%',
    color: 'white',
    backgroundColor: '#303E8A',
    padding: 8,
    fontSize: 25,
    cursor: 'pointer',
    marginRight: 10
  },
  eventControlIconSelected: {
    backgroundColor: '#D7D7D7',
    color: '#9F9F9F',
  },
  eventDetailContent: {
    padding: '10px 10px 50px 10px',
    display: 'flex'
  },
  eventListDate: {
    margin: 0,
    fontSize: 13,
    fontWeight: 600
  },

})



// WEBPACK FOOTER //
// ./src/common/components/EventVideoDialogFunction.js